export const Header = (function () {
	'use strict';

	let $menu, $menuButton, $subMenuParent, $subMenuItem, $body, $search_toggle, $notification_bar, $notification_close;

	function init() {
		($menu = $('.site-header__nav .nav-items')), ($menuButton = $('.mobile-menu-button'));
		$body = $('body');
		$subMenuParent = $('.site-header .menu-item-has-children');
		$subMenuItem = $('.site-header .sub-menu a');
		$search_toggle = $('.search-toggle');

		$notification_bar = $('.notification-bar');
		$notification_close = $('.notification-close');

		events();
	}

	function setCookie(name,value,days) {
	    var expires = "";
	    if (days) {
	        var date = new Date();
	        date.setTime(date.getTime() + (days*24*60*60*1000));
	        expires = "; expires=" + date.toUTCString();
	    }
	    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
	}

	function getCookie(name) {
	    var nameEQ = name + "=";
	    var ca = document.cookie.split(';');
	    for(var i=0;i < ca.length;i++) {
	        var c = ca[i];
	        while (c.charAt(0)==' ') c = c.substring(1,c.length);
	        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	    }
	    return null;
	}

	function eraseCookie(name) {
	    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	}

	function events() {

		// would be better handled server side to prevent flicker
		// wrap the notification bar in a check for this cookie
		if ( getCookie('notification-bar') == 'closed' ) {
			$notification_bar.hide();
		}

		$notification_close.on('click', function(e) {
			e.preventDefault();
			setCookie('notification-bar', 'closed', 14);
			$notification_bar.hide();
		});

		$search_toggle.on('click', function(e) {
			e.preventDefault();
			$body.toggleClass('search--open');
			$('#search').focus();
		});

		$menuButton.click(function () {
			if ($menu.hasClass('open')) {
				$body.removeClass('mobile-menu-open');
				$menu.removeClass('open');
				$menuButton.removeClass('open').attr('aria-expanded', 'false');
			} else {
				$body.addClass('mobile-menu-open');
				$menu.addClass('open');
				$menuButton.addClass('open').attr('aria-expanded', 'true');
			}
		});
	}

	return {
		init: init,
	};
})();
